import { useMediaQuery } from '@material-ui/core'
import { Cancel } from '@material-ui/icons'
import { useRef } from 'react'
import { useDispatch } from 'react-redux'
import { isVeryNarrow } from 'util/screenUtils'
import MediaPlayer from './MediaPlayer'

export default function VideoOverlay() {
    const veryNarrow = isVeryNarrow(useMediaQuery)
    const blurStyles = {
        card: {
            zIndex: 50000,
            width: '100vw',
            margin: 'auto',
            position: 'fixed',
            border: '0.25em outset rgb(221 177 89)',
        }
    }
    const dispatch = useDispatch()
    const videoRef = useRef()
    const videoControlRef = useRef()

    const displayVideoPlayer = () => {
        return (
            <div ref={videoRef} style={{
                position: 'absolute', top: 0, left: 0,
                width: '100%'
            }}>
                <MediaPlayer
                    ref={videoControlRef}
                    dispatch={dispatch} />
            </div>

        )

    }
    const displayMain = () => {
        return (
            <>
                <div
                    style={{
                        backgroundColor: 'rgba(127,127,127,0.2)',
                        width: '100%',
                        height: '100%',
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        zIndex: 40000,
                        backdropFilter: 'blur(2px)',
                    }}
                />
                <div style={blurStyles.card}>
                    {displayVideoPlayer()}
                </div>
                <Cancel style={{
                    position: 'fixed', top: 10,
                    fontSize: veryNarrow ? '2em' : '4em',
                    color: 'white',
                    right: 10,
                    zIndex: 50000
                }} />
            </>

        )
    }
    return displayMain()
}